import React from 'react';
import { LibraryHeaderProps } from './library-header-types';
import { HeaderContainer } from './style-component';
import { DropdownMenu } from '../dropdown-menu/dropdown-menu';
import { InputSearch } from '../input-search/input-search';

const LibraryHeader: React.FC<LibraryHeaderProps> = ({
    onSearch,
    onFilter,
    placeholder = 'Buscar...'
}) => {
    const hideFilter = true;
    return (
        <HeaderContainer>
            <InputSearch onSearch={onSearch} placeholder={placeholder}/>
            {!hideFilter && <DropdownMenu onSelect={onFilter}/>}
        </HeaderContainer>
    );
};

export default LibraryHeader;
